const initialState = {
  // bannerList: [],
  // categoryList: [],
  // showList: [],
  // unionConfig: {},

  creatAddressResult: {},
  updateAddressResult: {},
  deleteAddressResult: {},
};

// 收货地址
export default function receiveAddressDate(state = initialState, action) {
  switch (action.type) {
  case 'CREAT_ADDRESS':
    return { ...state, creatAddressResult: action.payload };
  case 'UPDATE_ADDRESS':
    return { ...state, updateAddressResult: action.payload };
  case 'DELETE_ADDRESS':
    return { ...state, deleteAddressResult: action.payload };
  default:
    return state;
  }
}